import * as React from 'react';

import { cn } from 'ui/lib/utils';

const Input = React.forwardRef<HTMLInputElement, React.ComponentProps<'input'>>(
	({ className, type, ...props }, ref) => {
		return (
			<input
				type={type}
				className={cn(
					'flex h-9 w-full rounded-sm border border-input bg-background px-3 py-1',
					'text-base text-foreground shadow-xs transition-colors font-lato',
					'file:border-0 file:bg-transparent file:text-sm file:font-medium file:text-foreground',
					'placeholder:text-muted-foreground',
					'focus-visible:outline-hidden focus-visible:ring-1 focus-visible:ring-ring',
					'disabled:cursor-not-allowed disabled:opacity-50 md:text-sm',
					className
				)}
				ref={ref}
				{...props}
			/>
		);
	}
);

Input.displayName = 'Input';

export { Input };
